import { createSelector } from "@reduxjs/toolkit";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/common/selectors/getVariationDraft";
import { getVariationInitialDraft } from "@src/store/slices/experienceBuilder/common/selectors/getVariationInitialDraft";
import { hasModChanges } from "@src/store/slices/experienceBuilder/common/utils/hasModChanges";

export const hasVariationDraftChanges = createSelector(
  getVariationInitialDraft,
  getVariationDraft,
  (initialMod, mod) => hasModChanges(initialMod, mod)
);
